/* SentinelX Security Systems - Theme JavaScript */

(function() {
  'use strict';

  // DOM Ready
  document.addEventListener('DOMContentLoaded', function() {
    initMobileMenu();
    initProductTabs();
    initCollapsibles();
    initQuantitySelectors();
    initAddToCart();
    initProductGallery();
  });

  // Mobile Menu
  function initMobileMenu() {
    const menuButton = document.querySelector('[data-mobile-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    const closeButton = document.querySelector('[data-mobile-menu-close]');

    if (!menuButton || !menu) return;

    menuButton.addEventListener('click', function() {
      menu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    if (closeButton) {
      closeButton.addEventListener('click', function() {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }

    menu.addEventListener('click', function(e) {
      if (e.target === menu) {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  // Product Tabs
  function initProductTabs() {
    const tabContainers = document.querySelectorAll('[data-product-tabs]');

    tabContainers.forEach(function(container) {
      const buttons = container.querySelectorAll('[data-tab-button]');
      const contents = container.querySelectorAll('[data-tab-content]');

      buttons.forEach(function(button) {
        button.addEventListener('click', function() {
          const tabId = this.getAttribute('data-tab-button');

          buttons.forEach(function(btn) {
            btn.classList.remove('is-active');
          });

          contents.forEach(function(content) {
            content.classList.remove('is-active');
          });

          this.classList.add('is-active');
          container.querySelector('[data-tab-content="' + tabId + '"]').classList.add('is-active');
        });
      });
    });
  }

  // Collapsibles
  function initCollapsibles() {
    const collapsibles = document.querySelectorAll('[data-collapsible]');

    collapsibles.forEach(function(collapsible) {
      const trigger = collapsible.querySelector('[data-collapsible-trigger]');

      if (!trigger) return;

      trigger.addEventListener('click', function() {
        collapsible.classList.toggle('is-open');
      });
    });
  }

  // Quantity Selectors
  function initQuantitySelectors() {
    const selectors = document.querySelectorAll('[data-quantity-selector]');

    selectors.forEach(function(selector) {
      const input = selector.querySelector('[data-quantity-input]');
      const decrementBtn = selector.querySelector('[data-quantity-decrement]');
      const incrementBtn = selector.querySelector('[data-quantity-increment]');

      if (!input) return;

      if (decrementBtn) {
        decrementBtn.addEventListener('click', function() {
          const currentValue = parseInt(input.value) || 1;
          const minValue = parseInt(input.min) || 1;
          if (currentValue > minValue) {
            input.value = currentValue - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      if (incrementBtn) {
        incrementBtn.addEventListener('click', function() {
          const currentValue = parseInt(input.value) || 1;
          const maxValue = parseInt(input.max) || 9999;
          if (currentValue < maxValue) {
            input.value = currentValue + 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    });
  }

  // Add to Cart
  function initAddToCart() {
    const forms = document.querySelectorAll('[data-add-to-cart-form]');

    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        const submitButton = form.querySelector('[type="submit"]');
        const formData = new FormData(form);

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.classList.add('loading');
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          body: formData
        })
        .then(function(response) {
          return response.json();
        })
        .then(function(data) {
          if (data.status === 422) {
            showNotification(data.message || 'Error adding to cart', 'error');
          } else {
            showNotification(window.cartStrings?.added || 'Added to cart!', 'success');
            updateCartCount();
          }
        })
        .catch(function(error) {
          console.error('Error:', error);
          showNotification('Error adding to cart', 'error');
        })
        .finally(function() {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('loading');
          }
        });
      });
    });
  }

  // Update Cart Count
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        const countElements = document.querySelectorAll('[data-cart-count]');
        countElements.forEach(function(el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });
      });
  }

  // Product Gallery
  function initProductGallery() {
    const galleries = document.querySelectorAll('[data-product-gallery]');

    galleries.forEach(function(gallery) {
      const mainImage = gallery.querySelector('[data-gallery-main]');
      const thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');

      thumbnails.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          const newSrc = this.getAttribute('data-gallery-thumbnail');
          
          if (mainImage) {
            mainImage.src = newSrc;
          }

          thumbnails.forEach(function(t) {
            t.classList.remove('is-active');
          });
          this.classList.add('is-active');
        });
      });
    });
  }

  // Notification
  function showNotification(message, type) {
    const existing = document.querySelector('.notification');
    if (existing) {
      existing.remove();
    }

    const notification = document.createElement('div');
    notification.className = 'notification notification--' + type;
    notification.innerHTML = '<span>' + message + '</span>';
    notification.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 9999; padding: 16px 24px; border-radius: 8px; font-size: 14px; font-weight: 500; animation: slideIn 0.3s ease-out;';

    if (type === 'success') {
      notification.style.background = '#10b981';
      notification.style.color = 'white';
    } else {
      notification.style.background = '#ef4444';
      notification.style.color = 'white';
    }

    document.body.appendChild(notification);

    setTimeout(function() {
      notification.style.animation = 'slideOut 0.3s ease-in';
      setTimeout(function() {
        notification.remove();
      }, 300);
    }, 3000);
  }

  // Add CSS for animations
  const style = document.createElement('style');
  style.textContent = '@keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } } @keyframes slideOut { from { transform: translateX(0); opacity: 1; } to { transform: translateX(100%); opacity: 0; } }';
  document.head.appendChild(style);

})();
